import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import dayjs from "dayjs";

export interface IPropertyDetailValidationAlert {
  id: number;
  message: string;
  name: string;
  isExpired: boolean;
}

export const prepareDetailPropertyAlertsValidation = (
  data: IPropertyDetailsResponse
): IPropertyDetailValidationAlert[] => {
  if (data?.validation_document_alerts?.length === 0) {
    return [];
  } else if (
    Object(data).hasOwnProperty("project") &&
    Object(data.project).hasOwnProperty("validation_documents") &&
    Object(data).hasOwnProperty("validation_document_alerts")
  ) {
    return data.validation_document_alerts.map(item => {
      const status = data.project.validation_documents.find(
        x => x.document_type_id === item.document_type_id
      );
      if (!status) {
        return {
          isExpired: dayjs(new Date()).isAfter(dayjs(item.alert_at)),
          id: item.id,
          name: item.document_type_name,
          message: `El documento ${
            item.document_type_name
          } debe ser suministrado, en caso de no ser suministrado, la propiedad se le dará de baja el ${dayjs(
            item.drop_at
          ).format("DD/MM/YYYY")}`
        };
      } else if (status.status === "pending") {
        return {
          isExpired: false,
          id: item.id,
          name: item.document_type_name,
          message: `El documento ${
            item.document_type_name
          } está pendiente aprobación, en caso de no ser aprobado, la propiedad se le dará de baja el ${dayjs(
            item.drop_at
          ).format("DD/MM/YYYY")}`
        };
      } else if (status.status === "rejected") {
        return {
          isExpired: false,
          id: item.id,
          name: item.document_type_name,
          message: `El documento ${
            item.document_type_name
          } ha sido rechazado, verifique el comentario de rechazo, y suministre el documento de nuevo, en caso de no ser suministrado, la propiedad se le dará de baja el ${dayjs(
            item.drop_at
          ).format("DD/MM/YYYY")}`
        };
      } else {
        return {
          isExpired: false,
          id: item.id,
          message: ``,
          name: item.document_type_name
        };
      }
    });
  } else {
    return [];
  }
};
